import { useState, useEffect, useContext, useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../Components/Layout/Layout";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { ManageApis } from "../../common/APIS/ManageApis";
import { ContextAPI } from "../../common/Context/ContextApi";
import { FailedPopup, JSONParse, customLogger, getSessionStorage, successPopup } from "../../common/Utils/Utils";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import NodataScreen from "../../Components/NodataScreen/NodataScreen";
import PopConfirm from "../../Components/PopupConfirm/PopConfirm";
import usePaymentSection from "./PaymentSection";
import PopupModal from "../../Components/PopupModal";
import PaymentStatusModal from "./PaymentStatusModal";
import { Constant } from "../../constant";


const PaymentList = () => {
  const navigate = useNavigate();
  const { auth, userdetails, redirect_url } = useParams();
  const { token, settoken, setnotificationsDetails, getNotification } = useContext(ContextAPI);
  const [data, setData] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [cartItemsLoan, setCartItemsLoan] = useState([]);
  const [cartItemsChitty, setCartItemsChitty] = useState([]);
  const [cartItemsGoldod, setCartItemGoldod] = useState([]);
  const [cartItemsPbod, setCartItemPbod] = useState([]);
  const [cartItemssugama, setCartItemSugama] = useState([]);
  const [loader, setLoader] = useState(false);
  



  const sessionData = getSessionStorage("userdetails");


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");

  useEffect(() => {
    if (auth && userdetails) {
      (async () => {
        localStorage.setItem("auth", auth);
        settoken(auth);
        let userBasicDetails = { ...JSONParse(userdetails), redirect_from: redirect_url };
        localStorage.setItem("userdetails", JSON.stringify(userBasicDetails));
        // handleMobileWebViewRequest();
      })();
    }
    return () => {
      if (redirect_url) {
        settoken("");
      }
    };
  }, [auth, userdetails]);

  useEffect(() => {

    if (status) {
      const accessToken = token | auth;
      if (accessToken) {
        getNotification(token);
      }
      setOpenPaymentStatusModal(true);
      setPaymentStatusMsg(
        status == "success"
          ? Constant.paymentsussessMsg
          : Constant.paymentFailMsg
      );

      setPaymentSuccess(status === "success");
    }
    // else if (status && sessionData.redirect_from) {
    //   const redirectURL = `${sessionData.redirect_from}?payment_result=${status === "failed" ? 0 : 1
    //     }${status === "failed" ? "&error=Payment Failed" : ""}`;
    //   window.location.href = redirectURL;
    // }
  }, [status]);

  useEffect(() => {
    if (token) {
      getCartDetails(auth);
    }
    return () => {
      clearCart();
    };
  }, [token]);

  // const handleRedirectToApp = (type, error, message) => {
  //   if (redirect_url) {
  //     let baseurl = sessionData?.redirect_from || redirect_url
  //     if (type != undefined) {
  //       baseurl += `?payment_result=${type}`
  //       setOpenPaymentStatusModal(true);
  //       //in this case 'type' is 0 that why here payment status always false, if passing a not 0 value kindly manage here
  //       setPaymentSuccess(false);
  //       setPaymentStatusMsg(message);
  //     } else {
  //       baseurl += type != undefined ? '&' : '?' + `error=${error}`
  //     }
  //     console.log('redirection url', { baseurl })
  //     // window.location.href = baseurl
  //   } return
  // }

  // const handleMobileWebViewRequest = useCallback(async () => {
  //   setLoader((prev) => true);
  //   const cartItems = await getCartDetails(auth);
  //   setLoader(true)
  //   if(!messageShown)
  //     handleBrowserCheck()
  //   setLoader(false)
  // }, [auth]);

  // const handleBrowserMessageClose = async() =>{
  //   setInvalidBrowserPopUp(invalidBrowserPopUpInitialValue)
  //   setMessageShown(true) 
  //   if (cartItems) {
  //     await getPaymentgateways(auth);
  //   } else {
  //     setOpenPaymentStatusModal(true);
  //     setPaymentSuccess(false);
  //     setPaymentStatusMsg(Constant.paymentFailMsg);
  //   }
  // }

  // const handleBrowserCheck = async() => {
  
  //   const userAgent = window.navigator.userAgent;

  //   // Check if it's Chrome on mobile
  //     const isMobileChrome = /Chrome\/[0-9.]+ Mobile/.test(userAgent) && !/SamsungBrowser/.test(userAgent);

  //     if (!isMobileChrome) {
  //       setInvalidBrowserPopUp({ show:true, message: "",navigateRequired:true })
  //       return;
  //     }

  //   const chromeVersionMatch = userAgent.match(/Chrome\/([0-9]+)/);
  //   const majorVersion = chromeVersionMatch ? parseInt(chromeVersionMatch[1], 10) : null;

  //   const fetchLatestMobileChromeVersion = async () => {
  //     try {
  //       setChromeVersionCheckLoader(true)
  //       const response = await fetch('https://versionhistory.googleapis.com/v1/chrome/platforms/android/channels/stable/versions');
  //       const data = await response.json();
  //       const latestVersion = data.versions[0].version;
        
  //       if(!latestVersion.includes(majorVersion)){
  //         // navigate("/login", { replace: true });
  //         setInvalidBrowserPopUp({ show:true, message: "" })
  //       }else{
  //         handleBrowserMessageClose()
  //       }
  //       setChromeVersionCheckLoader(false)
  //     } catch (error) {
  //       setChromeVersionCheckLoader(false)
  //       console.error('Error fetching the latest Chrome version:', error);
  //     }
  //   };

  //   await fetchLatestMobileChromeVersion();
    
  // }

  const clearCart = () => {
    setData({});
    setCartItems([]);
    setCartItemsLoan([]);
    setCartItemsChitty([]);
    setCartItemGoldod([]);
    setCartItemPbod([]);
    setCartItemSugama([]);
  };

  const getCartDetails = async (authToken = token) => {
    setLoader(true);
    setData({});
    try {
      let response = await ManageApis("get", global.cartDetails, "", authToken);
      if (response.response_data.status) {
        setLoader(false);
        if (response.response_data.data) {
          setData(response.response_data.data);
          let resData = response.response_data.data.cart_items;
          setCartItems(resData);
          setCartItemsLoan(resData.filter((item) => item.type === "loan"));
          setCartItemsChitty(resData.filter((item) => item.type === "chitty"));
          setCartItemGoldod(resData.filter((item) => item.type === "goldod"));
          setCartItemPbod(resData.filter((item) => item.type === "pbod"));
          setCartItemSugama(resData.filter((item) => item.type === "sugama"));
          return response.response_data.data;
        }
      } else {
        setLoader(false);
        setnotificationsDetails((prev) => ({ ...prev, cart_count: 0 }));
        clearCart();
        FailedPopup(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveCart = useCallback((id) => {
    return new Promise((resolve, reject) => {
      setLoader(true);
      let path = global.removeCartItem + `?cart_item_id=${id}`;
      ManageApis("delete", path, "", token)
        .then((res) => {
          if (res.response_data.status) {
            setnotificationsDetails((prev) => ({ ...prev, cart_count: prev.cart_count - 1 }));
            setLoader(false);
            successPopup(res);
            setCartItems(cartItems.filter((itm) => itm._id !== id));
            setCartItemsLoan(cartItemsLoan.filter((itm) => itm._id !== id));
            setCartItemsChitty(cartItemsChitty.filter((itm) => itm._id !== id));
            setCartItemGoldod(cartItemsGoldod.filter((itm) => itm._id !== id));
            setCartItemPbod(cartItemsPbod.filter((itm) => itm._id !== id));
            setCartItemSugama(cartItemssugama.filter((itm) => itm._id !== id));
            getCartDetails();
          } else {
            setLoader(false);
            FailedPopup(res);
          }
          resolve();
        })
        .catch((err) => {
          customLogger("error in delete a cart item", err);
          reject();
        });
    });
  }, [cartItems, cartItemsLoan, cartItemsChitty, cartItemsGoldod, cartItemsPbod, cartItemssugama, token]);

  const handleAfterPayment=()=>{
    setnotificationsDetails((prev) => ({ ...prev, cart_count: 0 }));
    clearCart();
  }

    // Use the custom hook
    const {
      paymentModalVisible,
      PaymentGateWays,
      loader: paymentLoader,
      buttonDisable,
      OpenPaymentStatusModal,
      paymentPending,
      paymentSuccess,
      setPaymentSuccess,
      setOpenPaymentStatusModal,
      paymentStatusMsg,
      setPaymentStatusMsg,
      handleGateWay,
      handleClosePaymentModal,
      getPaymentgateways,
      PaymentBackbtn,
      showPriceBanner
  } = usePaymentSection(token, redirect_url, handleAfterPayment);
  

 
  

    const handleBackBtn = () => {
      let path = window.location.pathname;
      const navigateBack = () => {
        if (path === "/cart") {
          navigate(-1);
          setTimeout(() => {
            path = window.location.pathname;
            navigateBack();
          }, 100);
        }
      };
      
      navigateBack();
    };

  return (
    <Layout loading={loader || paymentLoader}>
      <div className="pt-3 pb-4 px-3 px-md-4 overflow-auto custom_scroll1">
        <div className="mb-3">
          <div className="mb-3">
            <div className="align-items-center d-flex justify-content-between flex-wrap">
              <BackBtn
                handleBackBtn={handleBackBtn}
                title={`Payment List`}
              />
              <div className="col-12 col-sm-auto pt-3 pt-sm-2">
                <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-3">
                  <Link to={"/"} className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100 ws_nowrp min_w_unset">
                    Add More
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {data?.count ? (
            <div className="p-3 bg-white br_10 shadow_sm">
              {cartItemsChitty.length > 0 && (
                <>
                  <h5 className="font_14 fw_600 mb-0 pb-2 text_master">Chitty</h5>
                  <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle mb-3">
                    <thead className="bg_master text-white">
                      <tr>
                        <th className="fw_500" style={{ width: "60px" }}>Sl.No</th>
                        <th className="fw_500">Scheme Name</th>
                        <th className="fw_500" style={{ width: "250px" }}>Scheme Details (Chittal No.)</th>
                        <th className="fw_500 text-end" style={{ width: "120px" }}>Amount</th>
                        <th className="fw_500" style={{ width: "90px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItemsChitty?.map((item, idx) => (
                        <tr key={item._id}>
                          <td>{idx + 1}</td>
                          <td>{item.cartItemDetails.chit_no}</td>
                          <td>{item.cartItemDetails.chittal_no}</td>
                          <td className="text-end">{item.amount}</td>
                          <td>
                            <PopConfirm onOk={() => handleRemoveCart(item._id)}>
                              <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">Delete</button>
                            </PopConfirm>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {cartItemsLoan.length > 0 && (
                <>
                  <h5 className="font_14 fw_600 mb-0 pb-2 text_master">Loan</h5>
                  <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle mb-3">
                    <thead className="bg_master text-white">
                      <tr>
                        <th className="fw_500" style={{ width: "60px" }}>Sl.No</th>
                        <th className="fw_500">Loan Id</th>
                        <th className="fw_500" style={{ width: "250px" }}>Type</th>
                        <th className="fw_500 text-end" style={{ width: "120px" }}>Amount</th>
                        <th className="fw_500" style={{ width: "90px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItemsLoan?.map((item, idx) => (
                        <tr key={item._id}>
                          <td>{idx + 1}</td>
                          <td>{item.cartItemDetails.loan_id}</td>
                          <td>{item.cartItemDetails.loan_description || "Loan"}</td>
                          <td className="text-end">{item.amount}</td>
                          <td>
                            <PopConfirm onOk={() => handleRemoveCart(item._id)}>
                              <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">Delete</button>
                            </PopConfirm>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {cartItemsGoldod.length > 0 && (
                <>
                  <h5 className="font_14 fw_600 mb-0 pb-2 text_master">Smart Gold Loan</h5>
                  <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle">
                    <thead className="bg_master text-white">
                      <tr>
                        <th className="fw_500" style={{ width: "60px" }}>Sl.No</th>
                        <th className="fw_500">Smart Gold Loan Id</th>
                        <th className="fw_500">Branch ID and Name</th>
                        <th className="fw_500" style={{ width: "250px" }}>Description</th>
                        <th className="fw_500 text-end" style={{ width: "120px" }}>Amount</th>
                        <th className="fw_500" style={{ width: "90px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItemsGoldod?.map((item, idx) => (
                        <tr key={item._id}>
                          <td>{idx + 1}</td>
                          <td>{item.cartItemDetails.goldod_no}</td>
                          <td>{item.cartItemDetails.branch_id}, {item.cartItemDetails.branch_name}</td>
                          <td>{item.cartItemDetails.goldod_description || "Loan"}</td>
                          <td className="text-end">{item.amount}</td>
                          <td>
                            <PopConfirm onOk={() => handleRemoveCart(item._id)}>
                              <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">Delete</button>
                            </PopConfirm>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {cartItemsPbod.length > 0 && (
                <>
                  <h5 className="font_14 fw_600 mb-0 pb-2 text_master">Smart PBL</h5>
                  <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle">
                    <thead className="bg_master text-white">
                      <tr>
                        <th className="fw_500" style={{ width: "60px" }}>Sl.No</th>
                        <th className="fw_500">Passbook OD Id</th>
                        <th className="fw_500">Branch ID and Name</th>
                        <th className="fw_500" style={{ width: "250px" }}>Description</th>
                        <th className="fw_500 text-end" style={{ width: "120px" }}>Amount</th>
                        <th className="fw_500" style={{ width: "90px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItemsPbod?.map((item, idx) => (
                        <tr key={item._id}>
                          <td>{idx + 1}</td>
                          <td>{item.cartItemDetails.pbod_no}</td>
                          <td>{item.cartItemDetails.branch_id}, {item.cartItemDetails.branch_name}</td>
                          <td>{item.cartItemDetails.pbod_description || "Passbook OD"}</td>
                          <td className="text-end">{item.amount}</td>
                          <td>
                            <PopConfirm onOk={() => handleRemoveCart(item._id)}>
                              <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">Delete</button>
                            </PopConfirm>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {cartItemssugama.length > 0 && (
                <>
                  <h5 className="font_14 fw_600 mb-0 pb-2 text_master">Sugama</h5>
                  <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle">
                    <thead className="bg_master text-white">
                      <tr>
                        <th className="fw_500" style={{ width: "60px" }}>Sl.No</th>
                        <th className="fw_500">Sugama No</th>
                        <th className="fw_500" style={{ width: "250px" }}>Branch ID and Name</th>
                        <th className="fw_500 text-end" style={{ width: "120px" }}>Amount</th>
                        <th className="fw_500" style={{ width: "90px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItemssugama?.map((item, idx) => (
                        <tr key={item._id}>
                          <td>{idx + 1}</td>
                          <td>{item.cartItemDetails.sugama_no}</td>
                          <td>{item.cartItemDetails.branch_id}, {item.cartItemDetails.branch_name}</td>
                          <td className="text-end">{item.amount}</td>
                          <td>
                            <PopConfirm onOk={() => handleRemoveCart(item._id)}>
                              <button className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100">Delete</button>
                            </PopConfirm>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          ) : (
            <NodataScreen title="No items found in cart" />
          )}
        </div>
        {data?.count && (
          <div className="bg-white px-3 py-3 br_10 shadow_sm mb-3">
            <div className="align-items-center d-flex justify-content-end flex-wrap">
              <div className="col-12 text-end">
                <span className="pe-2 text-uppercase">Net Amount : </span>
                <span className="text-black word_break fw_600 font_14 d-inline-block min_w_65x">{data?.total_amount}</span>
              </div>
              <div className="col-12 pt-2 text-end">
                <button
                  className="btn px_btn btn-master px-4 rounded fw_500 font_12"
                  onClick={getPaymentgateways}
                >
                  Proceed to Payment
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <PopupModal
        visible={paymentModalVisible}
        handleClose={handleClosePaymentModal}
        title="Select Payment Gateway"
        size="md"
        Backdrop={"static"}
        closeButton={!buttonDisable}
      >
        <div id="payment-gateways-list">
          <Row className="g-3">
            {PaymentGateWays.map((item) => (
              <Col xs={4} key={item.gatewayId}>
                <button
                  className="btn bg-white p-2 d-grid shadow_sm1 rounded cursor_pointer w-100 h-100"
                  disabled={buttonDisable}
                  onClick={() => handleGateWay(item.gatewayId, item.merchantKey, { total_amount: data?.total_amount },false)}
                >
                  <div>
                    <img src={item.gateway_logo} className="h_80x object_fit_contain w-100" alt={item.gatewayId} />
                  </div>
                  <h6 className="mb-0 pt-2 text-center font_14 fw_600">{item.details}{ item.gatewayId === 'SBI' && (<sup className="text-danger font_14">**</sup>)}</h6>
                </button>
              </Col>
            ))}
            {showPriceBanner && (
              <div className="mb-0 pt-2 text-center font_14 fw_600"><span className="text-danger">**</span>Charges apply for Net Banking transactions. Rs.20/- plus GST per transaction.</div>
            )}
          </Row>
        </div>
      </PopupModal>

      <PaymentStatusModal
        show={OpenPaymentStatusModal}
        status={paymentSuccess ? "success" : paymentPending ? "pending" : "failed"}
        message={paymentStatusMsg}
        redirectUrl={redirect_url}
        onClose={PaymentBackbtn}
        sessionData={sessionData}
      />
      {/* <PopupModal
            visible={invalidBrowserPopUp.show}
            closeButton={false}
            title={"Info"}
            message={invalidBrowserPopUp.message}
            buttons={[{ text: "Ok", onPress: () => handleBrowserMessageClose(invalidBrowserPopUp?.navigateRequired) }]}
            >
              {invalidBrowserPopUp.message ? invalidBrowserPopUp.message : 
              <div>
              <p>To ensure the best experience while viewing this page, we recommend using Updated Version of Google Chrome as your default web browser.</p>
              <p>Additionally, please make sure that cookies are enabled in your browser settings.</p>
              <p>If you need assistance with setting up Google Chrome or enabling cookies, feel free to reach out!</p>
              </div>
              }
            </PopupModal> */}
    </Layout>
  );
};

export default PaymentList;